<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_MDLE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-module-submodule-select
              ref="smComboFrame0"
              class="dp_flex"
              :pageId="this.$options.name"
              :selectedMd="frame0.selectData.COD_MDLE"
              :selectedSmd="frame0.selectData.COD_SMDLE"
              :defaultMdOption="'all'"
              :defaultSmdOption="'all'"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_SEARCH_COND')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-7">
            <sui-code-select
              ref="condType"
              :selected="frame0.selectData.COD_COND"
              codeId="COD_MANU_SEARCH_COND"
              defaultOption="all"
              :initialSelectedIndex="0"
              class="width60"
            />
            <div class="comp_spacing" />
            <sui-text-field
              v-model="frame0.searchWord"
              maxlength="50"
              :disabled="false"
              :readonly="false"
              @keyup="onKeyUpInput"
              @keyup.enter="onClickSearch"
            />
          </div>
        </div>
        <div class="btn_wrap">
          <sui-button
            type="button"
            class="comm_btn_Reset"
            @click="onClickReset"
          >
            {{ $t("MSG_BTN_RESET") }}
          </sui-button>
          <sui-button
            v-permission:read="$options.name"
            type="button"
            class="comm_btn_Scr"
            @click="onClickSearch"
          >
            {{ $t("MSG_BTN_SEARCH") }}
          </sui-button>
          </sui-button></sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <sui-grid
        ref="grid"
        :columns="gridColumns0"
        :dataset="'dsManual'"
        :rowMovable="false"
        :multiselect="true"
        :pageable="false"
        :showDisplayCountControl="false"
      />
    </sui-page-contents>
    <sui-page-footer>
      <div class="comm_btn_wrap">
        <sui-button
          type="button"
          class="comm_btn_border"
          @click="onClickCancel"
        >
          {{ $t('MSG_BTN_CANCEL') }}
        </sui-button>
        <sui-button
          type="button"
          class="comm_btn_solid"
          @click="onClickSelect"
        >
          {{ $t('MSG_BTN_SELT') }}
        </sui-button>
        </sui-button></sui-button>
      </div>
    </sui-page-footer>
  </sui-page>
</template>
<script>
// eslint-disable-next-line import/no-unresolved
import BasePage from '~cm/components/BasePage';

const dateFields = [
  'firstRegistrationDTM', 'finalModificationDTM', 'pageUsePriodStartDatetime', 'pageUsePriodFinishDatetime',
];
export default {
  name: 'PGE_CMU_00012', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    closePagePopup: {
      type: Function,
      default() {
        return null;
      },
    },
    pageInitialData: {
      type: Object,
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      frame0: {
        selectData: {
          COD_MDLE: {
            label: '',
            key: '',
          },
          COD_SMDLE: {
            label: '',
            key: '',
          },
          COD_COND: {
            label: '',
            key: '',
          },
        },
        searchWord: '',
      },
      localdata0: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_MDLE'),
        datafield: 'moduleName',
        width: '100',
      }, {
        text: this.$t('MSG_TXT_SMDLE'),
        datafield: 'subModuleName',
        width: '100',
      }, {
        text: this.$t('MSG_TXT_MANU_ID'),
        datafield: 'documentId',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
            handler: this.onGridSingleButtonClicked,
            type: 'link',
          }, this.dsManual, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
        width: '150',
      }, {
        text: this.$t('MSG_TXT_MANU_NM'),
        datafield: 'documentName',
      }],
      searchFieldOldText: '',
    };
  },
  computed: {},
  watch: {},
  datasets: [{
    id: 'dsManual',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { name: 'documentId', type: 'string', map: 'documentId' },
      { name: 'documentClassificationCode', type: 'string', map: 'documentClassificationCode' },
      { name: 'documentGeneralTypeCode', type: 'string', map: 'documentGeneralTypeCode' },
      { name: 'siteId', type: 'string', map: 'siteId' },
      { name: 'moduleCode', type: 'string', map: 'moduleCode' },
      { name: 'subModuleCode', type: 'string', map: 'subModuleCode' },
      { name: 'documentVersion', type: 'string', map: 'documentVersion' },
      { name: 'documentContent', type: 'string', map: 'documentContent' },
      { name: 'documentMultiLanguageId', type: 'string', map: 'documentMultiLanguageId' },
      { name: 'documentFileSN', type: 'string', map: 'documentFileSN' },
      { name: 'attachDocumentId', type: 'string', map: 'attachDocumentId' },
      { name: 'langId', type: 'string', map: 'langId' },
      { name: 'documentDetailContent', type: 'string', map: 'documentDetailContent' },
      { name: 'pageId', type: 'string', map: 'pageId' },
      { name: 'pageCount', type: 'string', map: 'pageCount' },
      { name: 'pageIdCount', type: 'string', map: 'pageIdCount' },
      { name: 'moduleName', type: 'string', map: 'moduleName' },
      { name: 'subModuleName', type: 'string', map: 'subModuleName' },
      { name: 'documentName', type: 'string', map: 'documentName' },
      { name: 'finalModificationUserId', type: 'string', map: 'finalModificationUserId' },
      { name: 'finalModificationDTM', type: 'string', map: 'finalModificationDTM' },
      { name: 'firstRegistrationDTM', type: 'string', map: 'firstRegistrationDTM' },
      { name: 'firstRegistrationUserId', type: 'string', map: 'firstRegistrationUserId' }],
  }],
  mounted() {
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    /**
     *  초기화
     */
    onClickReset() {
      this.$refs.condType.reset();
      // this.$refs.smComboFrame0.reset();
      this.frame0.selectData.COD_MDLE.key = 'ALL';
      this.frame0.selectData.COD_SMDLE.key = 'ALL';
      this.frame0.searchWord = '';
    },
    /**
     *  검색
     *  매뉴얼 목록 조회
     */
    onClickSearch() {
      const queryParams = {
        moduleCode: this.frame0.selectData.COD_MDLE.key,
        subModuleCode: this.frame0.selectData.COD_SMDLE.key,
        searchWord: this.frame0.searchWord,
        searchCond: this.frame0.selectData.COD_COND.key,
      };

      http.request(this.$options.name, 'DTS_CMU_00055', {
        query: queryParams,
      }).then(res => {
        utils.dateformatToClientInArray(res.data, dateFields);
        this.dsManual.setRawData(res.data);
      });
    },
    /**
     *  닫기
     */
    onClickCancel() {
      this.closePagePopup('');
    },
    /**
     *  선택
     */
    onClickSelect() {
      const selectedData = this.dsManual.getSelectedRawData();
      if (selectedData.length !== 0) {
        this.closePagePopup(selectedData);
      } else {
        // 선택 안했을 때
        //utils.messageBox('warning', this.$t('MSG_ALT_NOT_SEL_ITEM'));// 선택 된 항목이 없습니다.
        utils.messageBox('alert', null, this.$t('MSG_ALT_NOT_SEL_ITEM'));
      }
    },
    /**
     *  매뉴얼 조회 공통 팝업 호출
     */
    onGridSingleButtonClicked(value, dataRow) {
      utils.openLayerPopup('PGE_CMU_00013', null, {
        pageInitialData: {
          manualId: dataRow.documentId,
          type: 'manual',
        },
        size: 'lg',
      });
    },
    onKeyUpInput() {
      // _ 제외 특수문자 입력제한
      const searchFieldNewText = this.frame0.searchWord;
      if (utils.isExistSpecialChar(searchFieldNewText)) {
        utils.messageBox('warning', this.$t('MSG_ALT_NO_SPECL_CHAR'), null, () => {
          this.frame0.searchWord = this.searchFieldOldText;
        });
      } else {
        this.searchFieldOldText = searchFieldNewText;
      }
    },
  },
};
</script>
<style scoped>
</style>
